import React from "react";
import { Clock } from "lucide-react";
import { ChamadoAtual } from "../types";

interface ChamadoModalProps {
  chamadoAtual: ChamadoAtual;
  segundosRestantes: number;
}

export const ChamadoModal: React.FC<ChamadoModalProps> = ({
  chamadoAtual,
  segundosRestantes,
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-6 sm:p-8 md:p-10">
      <div className="w-full max-w-4xl rounded-2xl border-4 border-yellow-400 bg-gradient-to-br from-primary to-red-700 px-8 py-10 shadow-2xl sm:rounded-3xl sm:px-12 sm:py-14 md:px-16 md:py-16 lg:border-8 lg:px-20 lg:py-20">
        <div className="mb-8 flex flex-wrap items-center justify-center gap-6 sm:mb-12 sm:gap-8 md:gap-10">
          <div className="animate-bounce text-5xl sm:text-6xl lg:text-8xl">
            📞
          </div>
          <h2 className="text-center text-2xl font-black leading-tight text-yellow-300 drop-shadow-2xl sm:text-4xl lg:text-7xl">
            ENTREGADOR CHAMADO!
          </h2>
        </div>
        <div className="mb-8 rounded-2xl border-2 border-yellow-300 bg-white/30 px-6 py-6 backdrop-blur-sm sm:mb-12 sm:rounded-3xl sm:border-4 sm:px-10 sm:py-8 md:px-12 md:py-10">
          <p className="mb-3 text-center text-xl font-black text-white drop-shadow-lg sm:mb-5 sm:text-3xl lg:text-5xl">
            {chamadoAtual.nome} {chamadoAtual.sobrenome}
          </p>
          <p className="text-lg font-bold leading-snug text-yellow-200 sm:text-2xl lg:text-3xl">
            VÁ ATÉ A COZINHA PARA RETIRAR SEU PEDIDO!
          </p>
        </div>
        <div className="flex items-center justify-center gap-2 text-base font-bold text-yellow-200 sm:text-xl lg:text-2xl">
          <Clock className="h-5 w-5 shrink-0 sm:h-6 sm:w-6" />
          <span>
            Esta mensagem desaparecerá em {segundosRestantes} segundo
            {segundosRestantes !== 1 ? "s" : ""}
          </span>
        </div>
      </div>
    </div>
  );
};
